module.exports = __webpack_public_path__ + "static/media/aramco.f4f85ef6.png";